import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import * as React from 'react';
import AxiosConfig from 'axios-config';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { NoSsr } from '@mui/material';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import dayjs from 'dayjs';

const queryClient = new QueryClient();
AxiosConfig();
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Etc/GMT');

export default function Layout({ children }: React.PropsWithChildren) {
  return (
    <NoSsr>
      <QueryClientProvider client={queryClient}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>{children}</LocalizationProvider>
      </QueryClientProvider>
    </NoSsr>
  );
}
